import { Component } from '@angular/core'
import { ApexAxisChartSeries, ApexChart, ApexPlotOptions, ApexTooltip, NgApexchartsModule } from 'ng-apexcharts'

@Component({
    selector: 'app-sparkline',
    templateUrl: './sparkline.component.html',
    styleUrls: ['./sparkline.component.scss'],
    standalone: true,
    imports: [NgApexchartsModule],
})
export class SparklineComponent {
	public series: ApexAxisChartSeries
	public chart: ApexChart
	public tooltip: ApexTooltip
	public plotOptions: ApexPlotOptions
	constructor() {
		this.initChartData()
	}

	public initChartData(): void {
		let ts2 = 1
		let dates = []
		for (let i = 0; i < 30; i++) {
			ts2 = ts2 + 10
			dates.push([ts2, this.randomizeArray(dataSeries)[0][i].value])
		}
		window['Apex'] = {
			stroke: {
				width: 2,
			},
			markers: {
				size: 0,
			},
			tooltip: {
				fixed: {
					enabled: true,
				},
			},
		}
		this.tooltip = {
			fixed: {
				enabled: false,
			},

			x: {
				show: false,
			},
			y: {
				title: {
					formatter: function (seriesName) {
						return ''
					},
				},
			},
			marker: {
				show: false,
			},
		}
		this.series = [
			{
				name: 'XYZ MOTORS',
				data: this.randomizeArray(dates),
			},
		]
		this.chart = {
			type: 'bar',
			width: 150,
			height: 45,
			sparkline: {
				enabled: true,
			},
		}
	}

	randomizeArray(arg): number[] {
		var array = arg.slice()
		var currentIndex = array.length,
			temporaryValue,
			randomIndex

		while (0 !== currentIndex) {
			randomIndex = Math.floor(Math.random() * currentIndex)
			currentIndex -= 1

			temporaryValue = array[currentIndex]
			array[currentIndex] = array[randomIndex]
			array[randomIndex] = temporaryValue
		}

		return array
	}
}

export const dataSeries = [
	[
		{
			date: '2014-01-01',
			value: 1000,
		},
		{
			date: '2014-01-02',
			value: 9978,
		},
		{
			date: '2014-01-03',
			value: 3749,
		},
		{
			date: '2014-01-04',
			value: 5250,
		},
		{
			date: '2014-01-05',
			value: 1904,
		},
		{
			date: '2014-01-06',
			value: 6838,
		},
		{
			date: '2014-01-07',
			value: 3854,
		},
		{
			date: '2014-01-08',
			value: 7211,
		},
		{
			date: '2014-01-09',
			value: 2100,
		},
		{
			date: '2014-01-10',
			value: 1072,
		},
		{
			date: '2014-01-11',
			value: 2310,
		},
		{
			date: '2014-01-12',
			value: 1790,
		},
		{
			date: '2014-01-13',
			value: 8881,
		},
		{
			date: '2014-01-14',
			value: 6437,
		},
		{
			date: '2014-01-15',
			value: 2685,
		},
		{
			date: '2014-01-16',
			value: 6418,
		},
		{
			date: '2014-01-17',
			value: 2924,
		},
		{
			date: '2014-01-18',
			value: 7480,
		},
		{
			date: '2014-01-19',
			value: 8882,
		},
		{
			date: '2014-01-20',
			value: 9538,
		},
		{
			date: '2014-01-21',
			value: 5689,
		},
		{
			date: '2014-01-22',
			value: 9711,
		},
		{
			date: '2014-01-23',
			value: 9017,
		},
		{
			date: '2014-01-24',
			value: 6183,
		},
		{
			date: '2014-01-25',
			value: 7346,
		},
		{
			date: '2014-01-26',
			value: 9852,
		},
		{
			date: '2014-01-27',
			value: 2783,
		},
		{
			date: '2014-01-28',
			value: 3783,
		},
		{
			date: '2014-01-29',
			value: 1783,
		},
		{
			date: '2014-01-30',
			value: 4783,
		},
		{
			date: '2014-01-31',
			value: 3783,
		},
	],
]
